import { ShippingTypeEnum } from "../../../../../enums/ShippingTypeEnum";

export const optionsShippingType = [
  { value: ShippingTypeEnum.PAC, label: "Econômico" },
  { value: "mini", label: "Super Econômico" },
  { value: ShippingTypeEnum.SEDEX, label: "Expresso" },
  { value: ShippingTypeEnum.OWN_DELIVERY, label: "Super Expresso" },
  { value: ShippingTypeEnum.ULTRA, label: "Ultra Expresso" },
];
